// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".css?v=" + "37b8e4cb9c802ee36d3c" + "";
};